<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" class="toolbar" :model="searchForm">
      <el-form-item label="商户单号">
        <el-input v-model="searchForm.orderNo" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="平台单号">
        <el-input v-model="searchForm.tradeNo" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="交易状态">
        <el-select v-model="searchForm.status" size="mini" style="width: 100px" clearable>
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
          v-model="searchForm.searchDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini" style="width: 250px" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary" size="mini">查询</el-button>
        <el-button @click="downloadDataList" type="primary" size="mini">导出明细</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      height="650"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        prop="no"
        label="序号"
        width="50"
        type="index"
      ></el-table-column>
      <el-table-column prop="orderNo" align="center" label="商户单号"></el-table-column>
      <el-table-column prop="tradeNo" align="center" label="平台单号"></el-table-column>
      <el-table-column prop="amount"
             header-align="center"
             align="right"
             label="金额" >
        <template slot-scope="scope">
          <span>{{ scope.row.amount / 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fee"
             header-align="center"
             align="right"
             label="费用">
        <template slot-scope="scope">
          <span>{{ scope.row.fee / 100 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="订单时间">
        <template slot-scope="scope">
          <span>{{ dateTransform(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" align="center" label="结果时间">
        <template slot-scope="scope">
          <span>{{ dateTransform(scope.row.dealTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="utr" header-align="center"  align="center" label="UTR"/>
      <el-table-column prop="status" align="center" label="状态">
        <template slot-scope="scope">
          <span>{{ getOrderStatus(scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="notifyStatus" align="center" label="回调状态">
        <template slot-scope="scope">
          <span v-if="scope.row.notifyStatus == 0">未回调</span>
          <span v-if="scope.row.notifyStatus == 1">已回调</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      @size-change="pageSizeChange"
      @current-change="pageIndexChange"
      :current-page="pageIndex"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="dataTotal"
    ></el-pagination>
  </section>
</template>

<script>
import api from "../../api/orderManage/payOutList";
import DataUtil from "../../utils/config/dataUtil";
import Enum from "../../utils/Enum/Enum";

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      dataTotal: 0,
      loading: false,
      tableData: [],
      statusList: Enum.orderStatus,
      searchForm: {
        orderNo: "",
        tradeNo: "",
        searchDate: this.getCurrentDate(),
        status: ""
      },
      merchantList: [],
    };
  },
  methods: {
    dateTransform(date) {
      return DataUtil.dateTransform(date);
    },
    date4Query(date) {
      return DataUtil.dateTransformYMD(date);
    },
    getOrderStatus(val) {
      return Enum.getOrderStatus(val);
    },
    search() {
      this.pageIndex = 1;
      this.bindGrid();
    },
    bindGrid() {
      this.loading = true;
      this.searchForm.isDownload = false;
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      content.pageNo = this.pageIndex;
      content.pageSize = this.pageSize;
      _data.content = content;
      api.getPayOutList(_data).then((res) => {
        this.logining = false;
        if (res.code == "0000") {
          this.loading = false;
          this.tableData = res.data.rows;
          this.dataTotal = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取当前日期（yyyy-MM-dd）
    getCurrentDate() {
      const today = new Date();
      const todayStr = today.toISOString().split('T')[0]; // 格式: yyyy-MM-dd
      return [todayStr, todayStr]; // 开始和结束都是当天
    },

    async downloadDataList() {
      this.searchForm.isDownload = true;
      if (!Array.isArray(this.searchForm.searchDate) ||
        this.searchForm.searchDate.length !== 2 ||
        !this.searchForm.searchDate[0] ||
        !this.searchForm.searchDate[1]) {
        this.$message.error("请选择支付时间");
        return;
      }
      // 校验3：计算日期差
      if (this.searchForm.searchDate && this.searchForm.searchDate.length === 2) {
        const startDate = new Date(this.searchForm.searchDate[0]);
        const endDate = new Date(this.searchForm.searchDate[1]);

        // 计算天数差
        const timeDiff = endDate.getTime() - startDate.getTime();
        const dayDiff = timeDiff / (1000 * 3600 * 24);

        if (dayDiff > 7) {
          this.$message.error("下载时间段，请不要超过7天！");
          return;
        }
      }
      let _data = {};
      let content = Object.assign({}, this.searchForm);
      _data.content = content;
      let res = await api.getPayOutSearchDownload(_data);

      // 检查响应是否为JSON错误信息
      if (res.type === "application/json" || res.size < 1024) {
        // 将Blob转换为文本，读取错误信息
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const result = JSON.parse(reader.result);
            if (result.code && result.code !== 200) {
              this.$message.error(result.message || "下载失败，请稍后重试");
            } else {
              this.$message.error("下载失败，请稍后重试");
            }
          } catch (e) {
            // 如果不是JSON，尝试作为文本读取
            this.$message.error(reader.result || "下载失败，请稍后重试");
          }
        };
        reader.readAsText(res);
        return;
      }

      const mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([res], { type: mimeType });

      const downloadURL = (window.URL || window.webkitURL).createObjectURL(
        blob
      );

      let a = document.createElement("a");
      const now = new Date();
      const timestamp = `${now.getFullYear()}${(now.getMonth()+1).toString().padStart(2,'0')}${now.getDate().toString().padStart(2,'0')}`;
      a.download = `代付对账单_${timestamp}.xlsx`;
      // 创建二进制对象
      a.href = downloadURL;
      // 模拟点击
      a.click();
      //释放资源并删除创建的a标签
      URL.revokeObjectURL(downloadURL); // a.href
    },

    // 分页
    pageSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.bindGrid();
    },
    pageIndexChange(val) {
      this.pageIndex = val;
      this.bindGrid();
    },
  },
  mounted: function() {
  },
  components: {},
};
</script>

<style lang="scss">
@import "../../assets/css/base";
.el-form-item {
  margin-bottom: 10px;
}
</style>
